<template>
  <Modal
    :title="$t('questionnaire.label.create.title')"
    name="CREATE_QUESTIONNAIRE_MODAL"
    actions
  >
    <template v-slot:body>
      <v-form ref="questionnaireForm" v-model="valid">
        <v-row>
          <v-col>
            <v-text-field
              v-model="questionnaire.name"
              :label="$t('questionnaire.label.create.name')"
              :rules="required"
              outlined
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              v-model="questionnaire.type"
              :label="`${$t('questionnaire.label.create.type')}*`"
              :rules="required"
              :items="type"
              item-value="value"
              item-text="name"
              outlined
            />
          </v-col>
        </v-row>

        <AdminServiceTypeSelect
          v-model="questionnaire.service_types"
          :label="$t('questionnaire.label.create.serviceType')"
          :showOutterLabel="false"
          :dense="false"
        />

        <HCheckbox
          v-model="questionnaire.must_be_sent"
          :label="$t('questionnaire.label.create.mustBeSent')"
        />
      </v-form>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal('CREATE_QUESTIONNAIRE_MODAL')"
        elevation="0"
        color="grey"
        text
      >
        {{ $t('appointment.closeModal.buttons.cancel') }}
      </v-btn>

      <v-btn
        @click="newQuestionnaire"
        :loading="isQuestionnaireLoading"
        :disabled="!valid"
        class="ml-5"
        color="primary"
        elevation="0"
      >
        {{ $t('create.save') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import HTextInput from '@/components/app/HTextInput'
import AdminServiceTypeSelect from '@/components/AdminServiceTypeSelect'
import HCheckbox from '@/components/app/HCheckbox'
import HAutocomplete from '@/components/app/HAutocomplete'
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'QuestionnaireCreate',
  components: {
    Modal,
    HTextInput,
    HAutocomplete,
    HCheckbox,
    AdminServiceTypeSelect
  },
  data() {
    return {
      valid: false,
      type: [
        { name: this.$t('questionnaire.label.type.DEFAULT'), value: 'DEFAULT' },
        { name: this.$t('questionnaire.label.type.CUSTOM'), value: 'CUSTOM' }
      ],
      questionnaire: {
        name: null,
        type: 'DEFAULT',
        must_be_sent: false,
        service_types: [],
      },
      required: [(v) => (!!v && v.trim() != '') || this.$t('rules.required')],
    }
  },
  computed: {
    ...mapGetters(['isQuestionnaireLoading']),
  },
  methods: {
    ...mapActions([

      'closeModal',
      'showErrorMessage',
      'saveQuestionnaire',
      'fetchQuestionnaires',
      'showSuccessMessage'
    ]),
    ...mapMutations(['setIsQuestionnaireLoading']),
    async newQuestionnaire() {
      this.setIsQuestionnaireLoading(true)
      this.saveQuestionnaire(this.questionnaire)
        .then(() => {
          this.resetForm()
          this.fetchQuestionnaires()
          this.closeModal('CREATE_QUESTIONNAIRE_MODAL')
          this.showSuccessMessage(this.$t('questionnaire.label.successCreation'))
        })
        .catch(({ data }) => {
          data?.errors && data?.errors?.length >= 1
            ? this.showErrorMessage(this.$t('questionnaire.label.create.' + data.errors[0].field) + ": " + data.errors[0].message)
            : this.showErrorMessage(data.message)
      })
      .finally(() => {
        this.setIsQuestionnaireLoading(false)
      })
    },
    resetForm() {
      this.questionnaire = {
        name: null,
        type: 'DEFAULT',
        must_be_sent: false,
        service_types: [],
      }
    },
  }
}
</script>
